import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import RemoveIcon from "@mui/icons-material/Remove";

import MDBox from "@/components/atoms/MDBox";
import MDTypography from "@/components/atoms/MDTypography";

type Props = {
  value: number | null | undefined;
  isPoints?: boolean;
  lowerIsBetter?: boolean;
  caption?: string;
};

const formatter = new Intl.NumberFormat("pt-BR", { maximumFractionDigits: 1 });

const VariationBadge = ({ value, isPoints = false, lowerIsBetter = false, caption }: Props) => {
  if (value === null || value === undefined) {
    return (
      <MDTypography variant="caption" color="text">
        --{caption ? ` ${caption}` : ""}
      </MDTypography>
    );
  }

  const isNeutral = value === 0;
  const isGood = lowerIsBetter ? value < 0 : value > 0;
  const color = isNeutral ? "text" : isGood ? "success" : "error";
  const Icon = isNeutral ? RemoveIcon : value > 0 ? ArrowUpwardIcon : ArrowDownwardIcon;
  const sign = value > 0 ? "+" : "";
  const unit = isPoints ? " p.p." : "%";

  return (
    <MDBox display="flex" alignItems="center" gap={0.25} sx={{ whiteSpace: "nowrap" }}>
      <MDTypography
        variant="caption"
        color={color}
        fontWeight="bold"
        display="flex"
        alignItems="center"
      >
        <Icon sx={{ fontSize: "0.85rem !important" }} />
        {`${sign}${formatter.format(value)}${unit}`}
      </MDTypography>
      {caption && (
        <MDTypography variant="caption" color="text">
          {caption}
        </MDTypography>
      )}
    </MDBox>
  );
};

export default VariationBadge;
